import { useEffect } from "react";

const getAllParentIds = (parent) => {
  if (!parent) {
    return [];
  }
  return [parent.id, ...getAllParentIds(parent.parent)];
};

export const useOpenAndScrollLeftSidebarTopologyItem = ({
  selectedTopologyItemId,
  treeRef,
}) => {
  useEffect(() => {
    if (!selectedTopologyItemId) {
      return;
    }
    if (!treeRef.current) {
      return;
    }

    // Delay for node to mount
    const openParentsTimeout = setTimeout(() => {
      if (!treeRef.current?.get) {
        return;
      }

      const node = treeRef.current.get(selectedTopologyItemId);
      if (!node) {
        return;
      }

      const parentIds = getAllParentIds(node);
      parentIds.forEach((id) => treeRef.current?.open?.(id));

      node.children?.forEach((child) => {
        // Added to catch if any of the children has a product name that contains "(2/N)" to also uncollapse them
        // No way to change the structure on EPF side to avoid this
        // https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_workitems/edit/50145
        if (
          child.children[0] &&
          /\(2\/\d\)/.test(child.children[0]?.data.productName)
        ) {
          child.toggle();
        }
        if (
          child.children[0] &&
          child.children[0]?.data.productName === "" &&
          child.data.kind === "component"
        ) {
          child.toggle();
        }
      });
    }, 0);

    // Delay scroll until after open
    const scrollTimeout = setTimeout(() => {
      if (!treeRef.current) {
        return;
      }

      treeRef.current.open?.(selectedTopologyItemId);
      treeRef.current.scrollTo?.(selectedTopologyItemId);
    }, 100);

    return () => {
      clearTimeout(openParentsTimeout);
      clearTimeout(scrollTimeout);
    };
  }, [selectedTopologyItemId, treeRef]);
};
